﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';

import AInntektValg from './Utilities/A-InntektValg';
import VeilederIofDto from './Models/VeilederIofDto';
import { VeilederIofAppState } from './Store';
import * as Ids from './Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import ResultatContainer from './Components/ResultatComponent';

import * as VisningsLogikk from './ResultatVisning';
import EkstraboksContainer from './Components/EkstraboksContainer';

import { Satser } from './Utilities/SatserApi';
import { tilPengerFormat } from '../Shared/Scripts/Utilities/Formatters';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederIofDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel } = this.props.epiContext;
        const { locale } = this.props.epiContext;

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aInntekt != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultat) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }
        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            if (satser != null) {
                const sats = tilPengerFormat(VisningsLogikk.getInntektsgrenseBostipendLaerlingelonn(satser), locale);

                return (
                    <div className="c-veileder">
                        {registerEvents()}
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksA}
                            tittel={contentResolver(epiContext, 'tittelInntekt')}
                            forklaring={contentResolver(epiContext, 'infoInntekt')}
                            sporsmal="ledetekstInntekt"
                            valg={AInntektValg.aValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ aInntekt: nyttValg });
                            }}
                            neverCollapse={true}
                            value={valg.aInntekt}
                        />
                        {resultat.visResultat && (
                            <ResultatContainer
                                resultat={VisningsLogikk.getResultat(valg)}
                                modal={VisningsLogikk.getModal(valg)}
                                satser={satser}
                                valg={valg}
                                eventId={eventId}
                            />
                        )}
                        {resultat.visEkstraboks && (
                            <EkstraboksContainer ekstraboks={VisningsLogikk.getEkstraboks(valg)} sats={sats} />
                        )}
                    </div>
                );
            } else if (resultat.visGenerellFeil) {
                return <FeilmeldingComponent />;
            } else return <div>Laster...</div>;
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederIofDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederIofAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederIofAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
